/** @module Sourcing/NewStyleFromSupplierRequestWizard */
define([
	"dojo/_base/declare",
	"csi/config",
	"Apparel/NewStyleWizard",
	"./StyleSupplierRequestWizardMixIn"
], function(declare,config,NewStyleWizard,StyleSupplierRequestWizardMixIn) {

	return declare([NewStyleWizard, StyleSupplierRequestWizardMixIn], {
		PRODUCT_SOURCE_CREATION_LEVEL: "ProductSourceCreationLevel",
		productSourceCreationLevel: null,

		onCreatePopupParams: function(/*Object*/params) {
			const parentNode = this.getParent();	
			this.productSourceCreationLevel = config.getSubtypeSetting(parentNode.Subtype, this.PRODUCT_SOURCE_CREATION_LEVEL);
		},

	});
});